export function featureTest() {
  return {
    POSITION_STICKY: (() => {
      const el = document.createElement('a')
      el.style.cssText = 'position: sticky; position: -webkit-sticky; position: -ms-sticky;'
      return el.style.position.indexOf('sticky') !== -1 ? false : 'dh-no-sticky'
    })(),
    BACKDROP_FILTER: (() => {
      const el = document.createElement('div')
      const style = el.style
      style.cssText = '-webkit-backdrop-filter: blur(2px); backdrop-filter: blur(2px);'

      if (
        (style.webkitBackdropFilter && style.webkitBackdropFilter.indexOf('blur(2px)') !== -1) ||
        (style.backdropFilter && style.backdropFilter.indexOf('blur(2px)') !== -1)
      ) {
        return false
      }
      return 'dh-no-backdrop-filter'
    })(),
    FILTER: (() => {
      const el = document.createElement('div')
      el.style.cssText = 'filter: blur(2px); filter: blur(2px);'
      return el.style.filter && el.style.filter.indexOf('blur(2px)') !== -1 ? false : 'dh-no-filter'
    })()
  }
}
